import { render } from "./FormBankInfo.vue?vue&type=template&id=649b7580&scoped=true"
import script from "./FormBankInfo.vue?vue&type=script&lang=js"
export * from "./FormBankInfo.vue?vue&type=script&lang=js"

import "./FormBankInfo.vue?vue&type=style&index=0&id=649b7580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-649b7580"]])

export default __exports__